import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUserData } from '../../utils/index';

const ProtectedRoute = ({ children }) => {
    // Check if user is logged in by checking localStorage
    const user = getUserData();
    const isAuthenticated = user && user.token;

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
